import { type FormInstance } from 'antd';

export const validateFormSilently = async (
  form: FormInstance,
  setState: (status: boolean) => void,
) => {
  form
    .validateFields({ validateOnly: true })
    .then(() => {
      setState(true);
    })
    .catch((errorInfo) => {
      errorInfo.errorFields.length ? setState(false) : setState(true);
    });
};
